import Splide from '@splidejs/splide';
import { gsap } from 'gsap';


console.log('hello world');


function initSplideCarousels(selector = '.js-splide') {
  document.querySelectorAll(selector).forEach((root) => {
    const captionEl = root.querySelector('.splide__caption p');

    const splide = new Splide(root, {
      arrows: true,
      pagination: true,
      type: 'fade',
      rewind: true,
    });

    const setCaption = (index) => {
      if (!captionEl) return;
      const slideEl = splide.Components.Slides.getAt(index)?.slide;
      captionEl.textContent = slideEl?.dataset.caption || '';
    };

    splide.on('mounted', () => setCaption(splide.index));
    splide.on('move', (newIndex) => setCaption(newIndex));

    splide.mount();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initSplideCarousels();
});


document.querySelectorAll('.text-block__nav a').forEach(link => {
  link.addEventListener('click', function (e) {
    e.preventDefault();

    const target = this.getAttribute('href');

    document.querySelectorAll('.text-block__nav a').forEach(a => {
      a.classList.toggle('active', a.getAttribute('href') === target);
    });

    document.querySelectorAll('.text-block__content--inner').forEach(section => {
      section.classList.toggle('is-active', '#' + section.id === target);
    });
  });
});

/* Accordion */
document.querySelectorAll('.accordion-item__header').forEach(function(header) {
  header.addEventListener('click', function() {
    var parent = this.closest('.accordion-item');

    parent.classList.toggle('clicked');

    /* Closes All Others
    document.querySelectorAll('.accordion-item').forEach(function(item) {
      if (!item.classList.contains('clicked')) {
        item.classList.remove('active');
        gsap.to(item.querySelector('.accordion-item__content'), 0.35, { height: 0 });
      }
    });
    */

    parent.classList.toggle('active');
    parent.classList.toggle('clicked');

    gsap.to(parent.querySelector('.accordion-item__content'), 0.35, { height: 0 });

    if (parent.classList.contains('active')) {
      gsap.to(parent.querySelector('.accordion-item__content'), 0.35, { height: 'auto' });
    }
  });
});